<template>
    <div
        ref="root"
    >
        <WujieVue v-bind="options"
                  :attrs="attrs"
                  class="h-full"
        />
    </div>
</template>

<script setup lang="ts">
import WujieVue from 'wujie-vue3';
import { wujieOptions } from '@analytics/patsnap-copilot/src/copilot';
import { getFiveMinutesRandomNumber } from '@eureka/utils/random-time';

const url = `${import.meta.env.VITE_MF_EUREKA_RESULT_COPILOT}/chat.html?t=${getFiveMinutesRandomNumber()}`;

const attrs = {
    src: `${window.location.origin}/empty.html`,
};

const options = wujieOptions({
    url,
});
</script>
